import {VERSION_GROUPS_PHASES_REQUEST, VERSION_GROUPS_PHASES_EDIT, VERSION_GROUPS_PHASES_CLEAR, VERSION_GROUPS_PHASES_FAIL} from "../store/config";

const versionGroupsPhasesInit = {
	isFetching: false,
	list: {},
	edit: {
		all_projects: true,
		phases:[]
	},
	pages: {
		current: 0,
		per_page: 0,
		total: 0
	},
	permissions: [],
	error: undefined,
	timestamp: undefined
}

const version_groups_phases = (state = versionGroupsPhasesInit, action) => {
	switch (action.type){
		case VERSION_GROUPS_PHASES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case VERSION_GROUPS_PHASES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit:{
					...state.edit,
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case VERSION_GROUPS_PHASES_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case VERSION_GROUPS_PHASES_FAIL:{
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		}
		default:
			return {
				...state
			}
	}
}

export default version_groups_phases;


// WEBPACK FOOTER //
// ./src/reducers/version_groups_phases.js